import { AppField, WrappedRecord } from "@smartsuite/types";
import { GridContext, GridContextValue } from "@smartsuite/grid/lib/src/Grid.context";
import { Context, useContext, useMemo } from "react";
import { GridSettings } from "@smartsuite/grid/lib/src/Grid.types";

export const useTableRowActionsPanelPosition = (record: WrappedRecord | null): number | null => {
  const { getRowPosition, scrollOptions } = useContext(
    GridContext as Context<GridContextValue<WrappedRecord, AppField, unknown, GridSettings>>
  );

  return useMemo(() => {
    if (!record) {
      return null;
    }

    const position = getRowPosition(record);
    return position ? position.top + scrollOptions.headHeight : null;
  }, [getRowPosition, record, scrollOptions.headHeight]);
};
